import { render, staticRenderFns } from "./Medusa.vue?vue&type=template&id=0ff7f573&scoped=true&"
import script from "./Medusa.vue?vue&type=script&lang=js&"
export * from "./Medusa.vue?vue&type=script&lang=js&"
import style0 from "./Medusa.vue?vue&type=style&index=0&id=0ff7f573&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff7f573",
  null
  
)

export default component.exports